import { mutationRequest } from "../util/request"

export const postUserInteraction = async (
  bandId,
  bandStreamId,
  referrer = null,
  interactionType = "page_view",
) => {
  mutationRequest({
    options: { method: "POST" },
    path: `/api/v1/bands/${bandId}/user_interactions`,
    data: {
      user_interaction: {
        interaction_type: interactionType,
        band_stream_id: bandStreamId,
        referrer: referrer,
      },
    },
  })
}

export const postUserMediaInteraction = async (
  bandId,
  interactionType = "media_play",
  postId,
  postType,
  interactionResult = null,
  playlistId = null,
  durationInSeconds = null,
) => {
  mutationRequest({
    options: { method: "POST" },
    path: `/api/v1/bands/${bandId}/user_interactions`,
    data: {
      user_interaction: {
        interaction_type: interactionType,
        post_id: postId,
        post_type: postType,
        interaction_result: interactionResult,
        playlist_id: playlistId,
        duration_in_seconds: durationInSeconds,
      },
    },
  })
}

// Idempotent progress ping for one specific playback (identified by playId).
// Safe to call repeatedly with the same playId - the server upserts by it and
// derives play/partial/skip from positionSeconds vs. the track's duration, so
// there's no "final" call this depends on landing for the data to be correct.
export const postUserInteractionHeartbeat = (
  bandId,
  playId,
  { postId, postType, positionSeconds, playlistId = null, algorithm = null, origin = "web_app" },
  requestOptions = {},
) => {
  return mutationRequest({
    options: { method: "PUT", ...requestOptions },
    path: `/api/v1/bands/${bandId}/user_interactions/${playId}`,
    data: {
      user_interaction: {
        post_id: postId,
        post_type: postType,
        position_seconds: positionSeconds,
        playlist_id: playlistId,
        algorithm: algorithm,
        origin: origin,
      },
    },
  })
}
